export const VIP_DEFAULT = {
  title: "VIP Signals & Algo",
  subtitle: "kaise join karein",
  intro: "Gold (XAUUSD) aur Bitcoin (BTCUSD) ke premium signals aur automated algo trading. Plan details aur joining ke liye seedha admin ko WhatsApp karein.",
  services: [
    { t: "VIP Signals", tag: "XAUUSD + BTCUSD", pts: ["Entry, Stop Loss aur Take Profit ke saath signals", "Instant app alert aur Telegram/WhatsApp update", "Trade management updates — partial close, SL move"] },
    { t: "Algo Trading", tag: "MT5 Automation", pts: ["Gold aur Bitcoin ke liye automated strategy", "Aapke MT5 account pe setup support", "Risk settings aapke capital ke hisaab se"] },
  ],
};
